module.exports = "https://static.wmbcdn.com/uniweb/images/dde8ad0007b93bba23a5b8e47db2db5d.svg";